import { gql } from '@apollo/client'

export const SETUP_PAYMENT_METHOD = gql`
  mutation SetupUserPaymentMethod {
    setupUserPaymentMethod
  }
`
